import React, {Component} from 'react';
import SlideMapWrapper from '../component/gammaviewer/openseadragon/SlideMapWrapper';
import {connect} from "react-redux";
import {componentIds, defaultScanTitle, openInNewTabType, responsiveLayers} from '../utils/const';
import {CssBaseline, Grid, Stack, ThemeProvider} from "@mui/material";
import HeadBar from "../component/gammaviewer/headbar";
import "../asset/style/neoviewer/slidemap.css"
import {morphleTheme1} from "../component/gammaviewer/themes"
import {openBottomApp, openTopApp, updateActiveMap, updateGammaState} from "../redux_actions/gamma.state.action";
import {getGammaStateFromUrl, getMapsStateFromUrl} from "../component/gammaviewer/utils/linkMakerUtils";
import AppTabs from "../component/gammaviewer/AppTabs";
import {barcodeApp, getAllSideBarBottomApps, getAllSideBarTopApps} from "../component/gammaviewer/app_maker";
import {checkAppPermission} from "../component/gammaviewer/utils/gammaScanUtils";
import {labellingLayer} from "../component/gammaviewer/utils/layers_info";
import LabellingMap from "../component/gammaviewer/LabellingMap";
import RightBottom from "../component/gammaviewer/rightBottom";
import TawkBot from "../component/gammaviewer/components/tawkBot";
import cookie from "react-cookies";
import {calculateClientHeightRatio, calculateClientWidthRatio, debounce, isTrue, notNull} from "../utils/utils";
import {loadMorpheusSetting} from "../redux_actions/morpheus.setting.action";
import {loadOsdViewerConfig} from "../redux_actions/osd.viewer.config.action";
import {isAppHiddenForViewer, requestOsdApp, resolveActiveViewer} from "../component/gammaviewer/openseadragon/viewerSelection";
import {LoadingText, SlideError,} from "../component/gammaviewer/components/components";
import TileSlideMap from "../component/gammaviewer/TileSlideMap";
import {clearMapsState, initMapsState,} from "../redux_actions/maps.state.action";
import {tourGuideForScan} from './websiteTourUtils';
import MobileGammaView from "../component/gammaviewer/mobileGammaView";
import ZoomControl from "../component/gammaviewer/rightBottom_apps/zoomControl";
import {saveMapsPosition} from "../component/gammaviewer/utils/splitSyncUtils";
import {setSlideToNotLoading} from "../redux_actions/slideLoading.action";
import {DELETED_SLIDE_ERROR, PERMISSION_DENIED_ERROR, SLIDE_NOT_FOUND_ERROR} from "../redux_constants/maps.state.const";
import ShareModal from "../component/utils/shareModal";
import RGBCurvesOverlay from "../component/gammaviewer/components/RGBCurvesOverlay";
import AiChatPopoutOverlay from "../component/gammaviewer/components/AiChatPopoutOverlay";

export class Scan extends Component {

    constructor(props) {
        super(props);
        this.onResize = this.onResize.bind(this);
    }

    componentDidMount = () => {
        this.props.dispatch(loadMorpheusSetting());
        this.props.dispatch(loadOsdViewerConfig());
        let maps = getMapsStateFromUrl();
        if (maps.length > 0) {
            this.props.dispatch(initMapsState(maps, true));
        } else {
            this.props.dispatch(initMapsState([{slideId: this.props.match.params.id}]));
        }
        this.props.dispatch(updateGammaState(getGammaStateFromUrl()));
        this.debouncedOnResize = debounce(this.onResize, 200)
        window.addEventListener("resize", this.debouncedOnResize);
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
        this.tourGuide();
        window.addEventListener("popstate", this.handlePageReload);
    }

    tourGuide = () => {
        setTimeout(() => {
            if (isTrue(this.props.tourActiveForScan)) {
                tourGuideForScan();
            }
        }, 1000)
    }

    componentWillUnmount() {
        this.props.dispatch(setSlideToNotLoading());
        this.props.dispatch(clearMapsState());
        this.props.dispatch(updateActiveMap(null))
        window.removeEventListener("resize", this.debouncedOnResize);
        window.removeEventListener("popstate", this.handlePageReload);
    }

    handlePageReload = () => {
        if (this.props.location.pathname.includes("/gamma")) {
            window.location.reload(true);
        }
    }


    onResize = (e) => {
        this.setState({});

        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.topApp && !this.props.bottomApp && this.props.topApp)
            this.props.dispatch(openBottomApp(barcodeApp));
        if (prevProps.tourActiveForScan !== this.props.tourActiveForScan && isTrue(this.props.tourActiveForScan)) {
            this.tourGuide();
        }
        if (isTrue(this.props.sync) && this.props.sync !== prevProps.sync) {
            saveMapsPosition(this.props.mapsState);
        }
        if (prevProps.activeViewer !== this.props.activeViewer) {
            if (isAppHiddenForViewer(this.props.topApp, this.props.activeViewer))
                this.props.dispatch(openTopApp(false));
            if (isAppHiddenForViewer(this.props.bottomApp, this.props.activeViewer))
                this.props.dispatch(openBottomApp(false));
        }
    }

    openTopApp = (app) =>
        requestOsdApp(app).then(proceed => proceed && this.props.dispatch(openTopApp(app)));

    openBottomApp = (app) =>
        requestOsdApp(app).then(proceed => proceed && this.props.dispatch(openBottomApp(app)));

    isAppShown = (app) => checkAppPermission(app) && !isAppHiddenForViewer(app, this.props.activeViewer);

    activeMapId = (id) => {
        this.props.activeMapId !== id && this.props.dispatch(updateActiveMap(id))
    };

    render() {
        let activeMapState = this.props.mapsState[this.props.activeMapId] || {};
        let displayedMapState = this.props.mapsState[this.props.displayedMapId] || {};

        if (displayedMapState.deletedSlideError) {
            return <SlideError type={DELETED_SLIDE_ERROR}/>
        } else if (displayedMapState.notFoundError) {
            return <SlideError type={SLIDE_NOT_FOUND_ERROR}/>
        } else if (displayedMapState.permissionDenied) {
            return <SlideError type={PERMISSION_DENIED_ERROR}/>
        }
        let viewerComponent = [];
        let headBarHeight = 48;

        if (this.props.activeAnnoDrawer === labellingLayer.drawer && activeMapState.slide) {
            viewerComponent = <LabellingMap/>;
        } else if (this.props.tileMapEnable && activeMapState.slide) {
            viewerComponent = <TileSlideMap {...activeMapState} mapsState={this.props.mapsState}
                                            height={calculateClientHeightRatio(0.95)}
                                            width={calculateClientWidthRatio(1)}/>;
        } else {
            let mapsState = Object.values(this.props.mapsState);
            //DIsplay only a single mapId among multiple mapIds
            if (notNull(this.props.displayedMapId)) {
                mapsState = mapsState.filter(mapState => mapState.id === this.props.displayedMapId);
            }
            let n_maps = mapsState.length;
            let rows = Math.round(Math.sqrt(n_maps));
            let cols = Math.ceil(n_maps / rows);

            // expand last one if any space is left
            let left_space = rows * cols - n_maps;
            let cols_for_last_row = 12 / (cols - left_space);

            for (let i = 0; i < mapsState.length; i++) {
                let mapState = mapsState[i];

                let is_last_row = i >= (rows - 1) * cols

                viewerComponent.push(<Grid item xs={is_last_row ? cols_for_last_row : 12 / cols}>
                    {mapState.slide ?
                        <SlideMapWrapper {...mapState} mapsState={mapsState} showName={n_maps > 1}
                                  onClick={() => this.activeMapId(mapState.id)} activeMapId={this.props.activeMapId}
                                  showBorder={n_maps > 1 && this.props.activeMapId === mapState.id}
                                  height={calculateClientHeightRatio(1 / rows, document.documentElement.clientHeight - headBarHeight)}
                                  bloodMapEnable={false}/> :
                        <LoadingText color={"background.paper"}/>
                    }
                </Grid>)
            }
        }

        let headbar, sideBarTop, sideBarBottom, rightBottom, tawkBotComponent;
        if (Object.keys(this.props.morpheusSetting).length > 0) {
            headbar = <HeadBar headBarHeight={`${headBarHeight}px`}/>;

            const bottomAppHeight = document.documentElement.clientHeight <= 500 ? 150 : 250;
            const topAppHeight = document.documentElement.clientHeight - headBarHeight - bottomAppHeight;

            sideBarTop = <AppTabs
                key={`top-${this.props.activeViewer}`}
                height={`${topAppHeight}px`}
                apps={getAllSideBarTopApps().filter(this.isAppShown)}
                allAppsTab={true}
                alignItems={"flex-start"}
                open={this.props.topApp}
                openApp={this.openTopApp}
            />;

            sideBarBottom = <AppTabs
                key={`bottom-${this.props.activeViewer}`}
                height={`${bottomAppHeight}px`}
                apps={getAllSideBarBottomApps().filter(this.isAppShown)}
                alignItems={"flex-end"}
                open={this.props.bottomApp}
                openApp={this.openBottomApp}
            />;

            rightBottom = <RightBottom/>;

            tawkBotComponent = cookie.loadAll().tawk_bot === 'true' && <TawkBot/>;
        }

        document.title = notNull(activeMapState?.slide?.name) ? `${activeMapState?.slide?.name}` : defaultScanTitle;

        return (
            <div id={"gamma-scan"} key="view" className={"full-parent"}>
                <ThemeProvider theme={morphleTheme1}>
                    <CssBaseline/>
                    <Stack direction={"column"}>
                        {headbar}
                        <Grid id={componentIds.slideMaps} container marginTop={`${headBarHeight}px`}
                              height={document.documentElement.clientHeight - headBarHeight}>
                            {viewerComponent}
                        </Grid>
                        {!this.isMobile ? <Stack direction={"column"} position={'absolute'}
                                                 height={document.documentElement.clientHeight - headBarHeight}
                                                 marginTop={`${headBarHeight}px`} justifyContent={"space-between"}>
                            {sideBarTop}
                            {sideBarBottom}
                        </Stack> : null}
                    </Stack>
                    {/* TODO: [Priyanshu] Make layers in slidemap only, and seperate the right bottom menu */}
                    {this.isMobile ?
                        <div style={{position: 'absolute', bottom: 20, zIndex: 2}}>
                            <MobileGammaView/>
                        </div> : null}
                    {!this.isMobile ?
                        <div id={componentIds.rightBottomApps}
                             style={{position: 'absolute', bottom: 40, right: '30px', zIndex: 2}}>
                            {rightBottom}
                        </div> : <div id={componentIds.rightBottomApps}
                                      style={{position: 'absolute', bottom: 40, right: '30px', zIndex: 2}}>
                            <ZoomControl/>
                        </div>}
                    <div id={componentIds.tawkIntegration}
                         style={{position: 'absolute', top: 60, right: '30px', zIndex: 2}}>
                        {tawkBotComponent}
                    </div>
                    {this.props.notifications && this.props.notifications[0]}
                    {this.props.slideModalOpen ? <ShareModal type={openInNewTabType.SLIDE}/> : null}
                    <RGBCurvesOverlay />
                    <AiChatPopoutOverlay />
                </ThemeProvider>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    let {
        activeAnnoDrawer,
        activeMapId,
        displayedMapId,
        tileMapEnable,
        notifications,
        tawkBot,
        topApp,
        bottomApp,
        sync
    } = state.gammaStateReducer;
    let mapsState = state.mapsStateReducer;
    let morpheusSetting = state.morpheusSettingReducer;
    let {tourActiveForScan} = state.websiteTourReducer;
    let {slideModalOpen} = state.shareManagerReducer;

    return {
        activeAnnoDrawer,
        notifications,
        mapsState,
        activeMapId,
        displayedMapId,
        tileMapEnable,
        morpheusSetting,
        tawkBot,
        topApp,
        bottomApp,
        tourActiveForScan,
        sync,
        slideModalOpen,
        activeViewer: resolveActiveViewer(state),
    };

};

export default connect(mapStateToProps)(Scan);
